<app-pagetitle title="Registrar Categoria de Orçamento" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<form class="mb-3" [formGroup]="categoryForm" (ngSubmit)="onSubmit()">
    <h4 class="card-title">Categoria</h4>
    <div class="card col-12 mb-2">
        <div class="card-body">
            <div class="row">
                <!-- Name and Email -->
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">
                        <label class="form-label" for="nome">Nome da categoria</label>
                        <input type="text" class="form-control" formControlName="nome" [ngClass]="{
                            'is-invalid':
                            categoryForm.controls.nome.errors &&
                            categoryForm.get('nome')?.touched,
                          }" />
                        <div class="invalid-feedback"
                            *ngIf="categoryForm.get('nome')?.touched && categoryForm.get('nome')?.invalid">
                            O nome é obrigatório.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mb-3">
                    <div class="form-group">

                        <label class="form-label" for="tipoDeCalculo">Tipo De Calculo</label>

                        <select class="form-select" id="tipoDeCalculo" formControlName="tipoDeCalculo" [ngClass]="{
                            'is-invalid':
                            categoryForm.controls.nome.errors &&
                            categoryForm.get('nome')?.touched,
                          }">
                            <option value="3">Calculo Por Metro Quadrado</option>
                            <option value="1">Calculo Por Valor Unitário</option>
                            <option value="2">Calculo Por Valor Unitário + Pessoa</option>
                        </select>

                        <div class="invalid-feedback" *ngIf="
                            categoryForm.controls.tipoDeCalculo.errors &&
                            categoryForm.get('tipoDeCalculo')?.touched">

                            O tipo de cálculo é obrigatório.
                        </div>
                    </div>
                </div>
            </div>
          
            <div class="row mt-2">

                <div class="col-xl-6">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title mb-0">Categoria de Calculo <span ngbTooltip="Existem calculos de totais separados por despesas de itens operacionais e para materias separadamente." class="badge rounded-pill bg-warning ms-1">Info</span></h4>
                            
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div>
                                        <div class="form-check mb-2">
                                            <input class="form-check-input" type="radio" formControlName="tipoDeDespesa" id="formRadios2" value="1">
                                            <label class="form-check-label" for="formRadios2">
                                                Categoria para despesa de materiais 
                                            </label>
                                        </div>
                                        <div class="form-check mb-3">
                                            <input class="form-check-input" type="radio" checked="" formControlName="tipoDeDespesa" id="formRadios1" value="0">
                                            <label class="form-check-label" for="formRadios1" >
                                                Categoria para despesas operacionais
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>

    <div class="d-flex">
        <button (click)="voltar()" type="button" class="btn btn-soft-link waves-effect">Voltar</button>
        <button class="btn btn-success btn-sm w-md" type="submit">
            @if (loading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            } @else {
            Salvar
            }
        </button>
    </div>
</form>